export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70475b5fef209a71785dc12f574560159477c14f7f&name=pushAdClickData!'